import { render, staticRenderFns } from "./AiStaffMembers.vue?vue&type=template&id=5cf425b3&scoped=true"
import script from "./AiStaffMembers.vue?vue&type=script&lang=js"
export * from "./AiStaffMembers.vue?vue&type=script&lang=js"
import style0 from "./AiStaffMembers.vue?vue&type=style&index=0&id=5cf425b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf425b3",
  null
  
)

export default component.exports